import Axios from 'axios';
import HomeService from './homeService';
import LoginService from './loginService';
import UserService from './userService';
import CallCenterService from './callCenterService';

const apiUrl = '/api/';
Axios.defaults.headers.common.Accept = 'application/json';

export default {
  HomeService: new HomeService(Axios, apiUrl),
  LoginService: new LoginService(Axios, apiUrl),
  UserService: new UserService(Axios, apiUrl),
  CallCenterService: new CallCenterService(Axios, apiUrl),
};
